export const LANDING_PAGES: LandingPages = {
	DASHBOARD: {
		label: 'Dashboard',
		value: 'dashboard',
	},
	CAPACITY: {
		label: 'Capacity',
		value: 'capacity',
	},
	CARRIERS: {
		label: 'Network',
		value: 'carriers',
	},
	PROJECTS: {
		label: 'Projects',
		value: 'projects',
	},
};

export const CARRIER_LANDING_PAGES: LandingPages = {
	DASHBOARD: LANDING_PAGES.DASHBOARD,
	PROJECTS: {
		label: 'Projects',
		value: 'carriers/projects_board',
	},
	BIDS: {
		label: 'Bids',
		value: 'carriers/bids',
	},
	NETWORK: {
		label: 'Network',
		value: 'carriers/network',
	},
	PRICING: {
		label: 'Pricing',
		value: 'pricing',
	},
};

interface LandingPages {
	[key: string]: {
		label: string;
		value: string;
	};
}
